export const RepTabKeys = {
  live: 'in_stand',
  visited: 'visited_stand',
  // chat: 'group_chat',
  reps: 'other_reps',
  // threads: 'room_threads',
}
